import VideoPlayer from './VideoPlayer';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

VideoPlayer.schema = schema;
VideoPlayer.defaultProps = getEmptyDefaultProps(schema.propsSchema);

export default VideoPlayer;
